
































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import SecondaryButton from '@/components/Buttons/SecondaryButton/index.vue';
@Component({
  components: {
    PrimaryButton,
    SecondaryButton,
  },
  directives: { Sticky },
})
export default class PartnerSticky extends Vue {
  @Prop({}) approve!: string;

  @Prop({}) review!: string;

  @Prop({}) disable!: boolean;

  @Prop({}) reviewValue!: boolean;

  @Prop({}) userStatusFormatted!: string;

  @Prop({}) saving!: string;

  private disabledValue: boolean = false;

  private userStatus: any = '';

  @Watch('disable', { immediate: true })
  onDisablePropsChanged(val: boolean) {
    this.disabledValue = val;
  }

  @Watch('userStatusFormatted', { immediate: true })
  onDisableReview(val: string) {
    this.userStatus = val;
  }

  public onReview() {
    this.$emit('review');
  }

  public onApprove() {
    this.$emit('approve');
  }
}
